import Slider from 'react-slick';
import MainTitle from '../../components/Common/main-title';
import { CursorPagination } from '../../components/Common/cursor-pagination';
import { fieldTranslation } from '../../components/constants';
import container from '../../container';
import useLanguage from '../../hooks/useLanguage';
import { map } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { oss } from '../../scripts/utils';
import { SolutionsData } from '.';
import { postSolutionList } from './services';
import './mobile-solution.scss';
import { Link } from 'react-router-dom';

const MobileHome = () => {
  const [index, setIndex] = useState(0);
  const [data, setData] = useState<SolutionsData[]>([]);
  const { currentSite, updateObserve } = useContext(container);
  const { i18n } = useLanguage();
  useEffect(() => {
    if (currentSite.id) {
      postSolutionList({
        site: {
          id: currentSite.id
        }
      }).then((res) => {
        const result = res as unknown as SolutionsData[];
        setData(result);
        updateObserve();
      });
    }
  }, [currentSite.id]);

  const settings = {
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToScroll: 1,
    slidesToShow: 1,
    cssEase: 'linear',
    rows: 1,
    arrows: false,
    speed: 500,
    swipe: true,
    beforeChange: (current: number, next: number) => {
      setIndex(next);
    },
    centerPadding: '0px'
  };

  return (
    <div className="hidden-in-pc mobile-solution-wrapper">
      <MainTitle className="mobile-tabs-title" main={i18n(fieldTranslation, '行业解决方案')} />
      <Slider {...settings}>
        {map(data, (d, index) => {
          return (
            <div key={index} className="mobile-solution-item">
              <Link to={`/solution#${index}`}>
                <img data-src={oss(d.industry.indusIcon, 670, 256)} alt="" />
                <div className="mobile-solution-item-footer">
                  <div className="mobile-solution-item-footer-content">
                    <div className="mobile-solution-item-footer-title">{d.industry.name}</div>
                    <div className="mobile-solution-item-footer-desc line-clamp-3">{d.industry.desc}</div>
                  </div>
                  <div className="mobile-solution-item-footer-icon-wrapper">
                    {map(d.examples?.slice(0, 3), (item, i) => {
                      return (
                        <div key={i} className="icon">
                          <img src={oss(item.customerLogo, undefined, 50, 'lfit')} alt={item.customerName} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </Slider>

      <div className="mobile-solution-page">
        <CursorPagination
          count={data.length}
          activeIndex={index}
        />
      </div>
    </div>
  );
};

export default MobileHome;
